var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper rest-password-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/verify-identity"
    }
  }, [_c('h6', {
    staticClass: "login-highlight"
  }, [_vm._v("Back")])]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Reset Password")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.changePassword);
            }
          }
        }, [_c('ValidationProvider', {
          attrs: {
            "rules": "required|strong_password",
            "name": "New Password",
            "vid": "newpassword"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors;
              return [_c('b-form-group', {
                attrs: {
                  "label": "New Password",
                  "label-for": "input-1",
                  "state": errors.length || _vm.formErrorFlag ? false : null
                }
              }, [_c('div', {
                staticClass: "changeForm-group errorIcon_eye position-relative"
              }, [_c('b-form-input', {
                staticClass: "no-bg-icon",
                attrs: {
                  "autocomplete": "new-password",
                  "id": "input-1",
                  "type": _vm.newPasswordType,
                  "state": errors.length || _vm.formErrorFlag ? false : null,
                  "placeholder": "Enter your new password",
                  "aria-label": "New Password"
                },
                on: {
                  "input": _vm.onPasswordInput
                },
                model: {
                  value: _vm.newpassword,
                  callback: function callback($$v) {
                    _vm.newpassword = $$v;
                  },
                  expression: "newpassword"
                }
              }), _c('eye-button', {
                attrs: {
                  "id": "input-1",
                  "hideOnDefault": true,
                  "value": _vm.newpassword,
                  "className": "rest-toggle-eye-icon",
                  "type": "text"
                },
                on: {
                  "toggle": _vm.toggleNewPasswordVisibility
                }
              }), _c('b-form-invalid-feedback', [_c('div', [_vm._v(_vm._s(errors[0] || (_vm.formErrorFlag ? _vm.formErrors.error : '')))])])], 1)])];
            }
          }], null, true)
        }), _c('b-form-group', [_c('password-strength-bar', {
          attrs: {
            "password": _vm.newpassword
          },
          on: {
            "updateScore": _vm.setPasswordScore
          }
        })], 1), _c('ValidationProvider', {
          attrs: {
            "rules": "required|confirmed:newpassword",
            "name": "Re-Type New Password"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var errors = _ref3.errors;
              return [_c('b-form-group', {
                attrs: {
                  "label": "Re-Type New Password",
                  "label-for": "input-2",
                  "state": errors.length || _vm.formErrorFlag ? false : null
                }
              }, [_c('div', {
                staticClass: "changeForm-group position-relative",
                class: errors.length || _vm.formErrorFlag ? 'errorIcon_eye' : ''
              }, [_c('b-form-input', {
                staticClass: "no-bg-icon",
                attrs: {
                  "autocomplete": "new-password",
                  "id": "input-2",
                  "type": _vm.reTypePasswordType,
                  "state": errors.length || _vm.formErrorFlag ? false : null,
                  "placeholder": "Re-Type New Password",
                  "aria-label": "Re-Type Password"
                },
                model: {
                  value: _vm.confirmpassword,
                  callback: function callback($$v) {
                    _vm.confirmpassword = $$v;
                  },
                  expression: "confirmpassword"
                }
              }), _c('eye-button', {
                attrs: {
                  "id": "input-2",
                  "hideOnDefault": true,
                  "value": _vm.confirmpassword,
                  "className": "rest-toggle-eye-icon",
                  "type": "text"
                },
                on: {
                  "toggle": _vm.toggleReTypePasswordVisibility
                }
              }), _c('b-form-invalid-feedback', [_c('div', [_vm._v(_vm._s(errors[0] || (_vm.formErrorFlag ? _vm.formErrors.error : '')))])])], 1)])];
            }
          }], null, true)
        }), _c('button', {
          staticClass: "submit-btn mt-3 next-btn",
          attrs: {
            "disabled": _vm.verifyLoader || !_vm.newpassword || !_vm.confirmpassword,
            "type": "submit"
          }
        }, [_vm.verifyLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Change Password ")], 1)], 1)];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('Logincarsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "Rep Icon"
    }
  })]);
}]

export { render, staticRenderFns }